import { SET_TAX_INPUT_IS_VISIBLE } from './constants';

export const setTaxInputIsVisible = isVisible => ({
    type: SET_TAX_INPUT_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/TaxInputs/actions.js